export const environment = {
  production: true,
  API_URL: '',
  baseHref: '/ui/',
  CONFIG_TOOL_URL: '/configui/',
  WORKFLOW_ADMIN_URL: '/workflowable-admin/'
};
